import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { ConfigService } from '@core/shared/config';
import * as i0 from "@angular/core";
import * as i1 from "@core/shared/config";
export let ApiUrlInterceptor = /*#__PURE__*/(() => {
  class ApiUrlInterceptor {
    constructor(config) {
      this.config = config;
      this.apiUrl = this.config.buildPlatformUrl('backend');
    }
    intercept(req, next) {
      req = req.clone({
        url: this.prepareUrl(req.url)
      });
      return next.handle(req);
    }
    isAbsoluteUrl(url) {
      const absolutePattern = /^(\/\/|https?:\/\/|www.)?(localhost|[a-z0-9\-^]+\.[a-z]{2,10})(.*)$/i;
      return absolutePattern.test(url);
    }
    prepareUrl(url) {
      if (!this.isAbsoluteUrl(url)) {
        // convert relative URLs to API urls
        if (url.charAt(0) !== '/') url = '/' + url;
        if (url.startsWith('/api')) url = url.substring(4);
        url = this.apiUrl + url;
      }
      // replace multiple trailing slashes by a single one -- but for what situation??
      url = url.replace(/([^:]\/)\/+/g, '$1');
      return url;
    }
    static {
      this.ɵfac = function ApiUrlInterceptor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ApiUrlInterceptor)(i0.ɵɵinject(i1.ConfigService));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ApiUrlInterceptor,
        factory: ApiUrlInterceptor.ɵfac
      });
    }
  }
  return ApiUrlInterceptor;
})();